import 'jquery';
import 'sticky-kit';
import 'slick-carousel';

import moment from 'moment';

import { openAuthPopin } from '../../common/auth.es6';
import {
    initializeRealtorContactForm,
    initializeRealtorMessagePopin,
    initializeRealtorPhoneButton,
    initializeStickyContactForm,
} from '../../common/contact';
import { toggleClass } from '../../common/domHelpers.es6';
import Ga from '../../common/ga';
import { initializeListingDetailButton } from '../../common/listing';
import MapboxMap from '../../common/map/mapbox-map.es6';
import HTTPService from '../../common/services/HTTPService.es6';
import {
    EstateType,
    eventTypeWithEstateType,
    getThorViewEventProps,
    thorAvItems,
    thorDistributionType,
    thorFormatPlaceName,
    thorPushEvent,
} from '../../common/thor';
import { displayErrorToaster, displaySuccessToaster } from '../../common/toaster.es6';
import { isIE } from '../../common/utils';
import Wa from '../../common/wa';

const GA_CATEGORY = 'Annonce';
const WA_SOURCE = 'listing';

function initializeSlider() {
    const $slideshow = $('[data-listing-pictures]');
    const $legend = $('[data-listing-pictures-legend]');
    const $spinnerContainer = $('[data-slideshow-spinner-container]');
    const picturesLength = $slideshow.find('img').length;

    $slideshow.magnificPopup({
        delegate: '.slick-slide:not(.slick-cloned) a', // Avoid prepared slick slide (.slick-cloned) to be in the gallery
        type: 'image',
        closeOnContentClick: false,
        closeBtnInside: false,
        mainClass: 'mfp-with-zoom mfp-img-mobile',
        image: {
            verticalFit: true,
        },
        gallery: {
            enabled: true,
            tCounter: '<span class="mfp-counter">%curr%/%total%</span>', // markup of counter
        },
    });

    $slideshow.slick({
        lazyLoad: 'progressive',
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
    });

    $slideshow.on('afterChange', (event, slick, currentSlide) => {
        $legend.html(`${currentSlide + 1}/${slick.slideCount}`);
    });

    let counter = 0;

    $slideshow.on('lazyLoaded', (event, slick, $img) => {
        // Copy data-lazy-srcset to srcset
        if (isIE()) {
            $img.attr('src', $img.data('ie-src'));
        } else {
            $img.attr('srcset', $img.data('lazy-srcset'));
        }

        $img.on('load error', e => {
            // use placeholder if img does not exist
            if (e.type === 'error') {
                $img.removeAttr('srcset');
            }

            counter += 1;

            // verify if all images have been loaded to hide the spinner overlay
            if (counter === picturesLength) {
                if (document.readyState === 'complete') {
                    $spinnerContainer.hide();
                } else {
                    $(window).on('load', () => {
                        $spinnerContainer.hide();
                    });
                }
            }
        });
    });
}

function handlePriceFeedback(feedbackUrl) {
    const btnGroupWrapper = document.querySelector('[data-listing-feedback-button-group]');
    const evaluationBlock = document.getElementsByClassName('listing-price-evaluation')[0];
    const successBlock = document.querySelector('[data-listing-feedback-success]');

    let feedbackRating = '';
    let feedbackInteracted = false;
    let feedbackSubmitAttempt = false;

    $('[data-listing-feedback]').on('click', function onFeedbackClick() {
        const button = this;
        const btnGroup = button.parentElement.children;

        feedbackRating = button.dataset.listingFeedbackValue;

        for (let i = 0; i < btnGroup.length; i++) {
            btnGroup[i].classList.remove('btn--primary');
            btnGroup[i].classList.add('btn--secondary');
        }

        button.classList.remove('btn--secondary');
        button.classList.add('btn--primary');

        document.getElementsByClassName('listing-price-evaluation')[0].classList.remove('hide');

        Ga.send({
            hitType: 'event',
            eventCategory: GA_CATEGORY,
            eventAction: 'listing:price_feedback_button:clicked',
            eventLabel: 'listing:price_feedback_button',
        });
        Ga.send({
            hitType: 'event',
            eventCategory: GA_CATEGORY,
            eventAction: 'listing:price_feedback:landed',
            eventLabel: 'listing:price_feedback_form',
        });

        HTTPService.post(feedbackUrl, { buyer_price_rating: feedbackRating });
    });

    $('[data-listing-feedback-price]').on('click', () => {
        if (!feedbackInteracted) {
            feedbackInteracted = true;
            Ga.send({
                hitType: 'event',
                eventCategory: GA_CATEGORY,
                eventAction: 'listing:price_feedback:started',
                eventLabel: 'listing:price_feedback_form',
            });
        }
    });

    $('[data-listing-feedback-submit]').on('click', () => {
        const feedbackPriceInput = document.querySelector('[data-listing-feedback-price]');
        const feedbackPrice = feedbackPriceInput.value;
        const button = document.querySelector('[data-listing-feedback-submit]');
        const serverError = document.getElementById('serverError');
        const feedbackError = document.getElementById('feedbackError');

        if (serverError) {
            serverError.remove();
        }

        if (feedbackError) {
            feedbackError.remove();
        }

        const feedbackValues = { buyer_price_rating: feedbackRating };
        if (feedbackPrice.length) {
            feedbackValues.estimated_avg_fai_price = feedbackPrice;
        }

        if (!feedbackSubmitAttempt) {
            feedbackSubmitAttempt = true;
            Ga.send({
                hitType: 'event',
                eventCategory: GA_CATEGORY,
                eventAction: 'listing:price_feedback:submit_attempt',
                eventLabel: 'listing:price_feedback_form',
            });
        }

        HTTPService.post(feedbackUrl, feedbackValues)
            .then(() => {
                evaluationBlock.classList.add('hide');
                btnGroupWrapper.classList.add('hide');
                successBlock.classList.remove('hide');

                Ga.send({
                    hitType: 'event',
                    eventCategory: GA_CATEGORY,
                    eventAction: 'listing:price_feedback:submit_success',
                    eventLabel: 'listing:price_feedback_form',
                });
            })
            .catch(e => {
                if (e.response.status === 500) {
                    const serverErrorContainer = document.createElement('div');
                    const serverErrorMsg = document.createTextNode(
                        'Une erreur est survenue lors de votre estimation. Merci de réessayer ultérieurement',
                    );
                    serverErrorContainer.id = 'serverError';
                    serverErrorContainer.classList.add('text--error', 'margin-top');
                    serverErrorContainer.appendChild(serverErrorMsg);
                    document
                        .querySelector('[data-listing-feedback-price-container]')
                        .appendChild(serverErrorContainer);
                } else {
                    const errorContainer = document.createElement('div');
                    const errorMsg = document.createTextNode(
                        e.response.data.estimated_avg_fai_price[0],
                    );

                    feedbackPriceInput.parentElement.classList.add('field--invalid');
                    errorContainer.classList.add('text--error', 'margin-bottom');
                    errorContainer.id = 'feedbackError';
                    errorContainer.appendChild(errorMsg);
                    document
                        .querySelector('[data-listing-feedback-price-container]')
                        .insertBefore(errorContainer, button);
                }
            });
    });
}

/**
 * Toggle listing follow status
 *
 * @param {Number|String} listingId
 * @param {Boolean} followValue
 */
function toggleFollow(listingId, followValue) {
    return () =>
        HTTPService.put(`/annonces/${listingId}/follow`, {
            follow: followValue,
        }).then(({ data: { follow } }) => follow);
}

/**
 * Toggle listing follow status with a fallback on authentication when user is not authenticated
 *
 * @param {Number|String} listingId
 * @param {Boolean} followValue
 */
function toggleFollowWithAuthFallback(listingId, followValue) {
    const toggleListingFollow = toggleFollow(listingId, followValue);
    return toggleListingFollow().catch(
        error =>
            new Promise((resolve, reject) => {
                if (error.response && error.response.status && error.response.status === 403) {
                    openAuthPopin(
                        () => toggleListingFollow().then(resolve),
                        'from:listing:follow_button',
                        'Annonce',
                    );
                } else {
                    reject(error);
                }
            }),
    );
}

/**
 * On Follow button click handler
 * @param {*Object} event
 */

function onFollowListingClick(event) {
    event.preventDefault();

    const button = this;
    const currentFollowStatus = button.dataset.followStatus === 'True';

    toggleFollowWithAuthFallback(button.dataset.listingId, !currentFollowStatus, button)
        .catch(error => {
            window.console.error(error);
            displayErrorToaster(
                "Une erreur est survenue lors de l'enregistrement de cette annonce.",
            );
        })
        .then(follow => {
            const { iconUrl, iconUrlActive, uaEventCategory } = button.dataset;
            const followListingButtonText = button.querySelector(
                '[data-follow-listing-button-text]',
            );
            const followListingButtonIcon = button.querySelector(
                '[data-follow-listing-button-icon]',
            );

            displaySuccessToaster(
                follow
                    ? 'Votre annonce a bien été enregistrée'
                    : 'Votre annonce n’est plus enregistrée',
            );

            button.dataset.followStatus = follow ? 'True' : 'False';

            if (followListingButtonText && followListingButtonText.innerText) {
                followListingButtonText.innerText = follow ? 'Enregistré ' : 'Enregistrer';
            }

            if (followListingButtonIcon && followListingButtonIcon.src) {
                followListingButtonIcon.src = follow ? iconUrlActive : iconUrl;
            } else {
                toggleClass(button, 'listing-actions__item--active');
            }

            if (uaEventCategory) {
                const { uaEventActionPrefix, uaEventLabelPrefix } = button.dataset;
                Ga.send({
                    hitType: 'event',
                    eventCategory: uaEventCategory,
                    eventAction: `${uaEventActionPrefix}:${follow ? '' : 'un'}follow`,
                    eventLabel: `${uaEventLabelPrefix}:${follow ? '' : 'un'}follow_button`,
                });
            }
            if (follow) {
                const { listing, listings, transactionType } = MA.Context;
                const { index } = event.currentTarget.dataset;
                const estateType = index
                    ? EstateType[listings[index].item_type.key]
                    : EstateType[listing.item_type.key];
                const avItemsArgs = {
                    listing,
                    listings,
                    listName: 'classified_search_results',
                    name: 'classified',
                    transactionType,
                };
                thorPushEvent('add_to_whishlist', {
                    av_estate_type_global: estateType,
                    av_distribution_type_global: thorDistributionType(transactionType),
                    av_items: thorAvItems(avItemsArgs),
                });
            }
        });
}

/**
 * Bind every listing follow button with click handler
 *
 * @param {*String} delegationSelector
 */
export function bindFollowListingButton(delegationSelector) {
    const buttonSelector = '[data-follow-listing-button]';

    if (delegationSelector) {
        $(delegationSelector).on('click', buttonSelector, onFollowListingClick);
    } else {
        $(buttonSelector).on('click', onFollowListingClick);
    }
}

function initializeMap() {
    const wrapperElement = document.querySelector('[data-vector-map]');
    if (!wrapperElement) {
        return;
    }

    // eslint-disable-next-line no-new
    new MapboxMap(wrapperElement, undefined, {
        disableInfoWindows: true,
        showControls: true,
        onLoad: (map, mapboxMap, resolve) => {
            HTTPService.get(wrapperElement.dataset.geoJsonUrl).then(response => {
                if (
                    response.data.features.length === 1 &&
                    response.data.features[0].geometry.type === 'Point'
                ) {
                    // If we have only one feature and it is a Point, we want render a blue dot
                    const feature = response.data.features[0];
                    mapboxMap.registerFeatures('place', response.data);
                    map.setZoom(16);
                    map.setCenter(feature.geometry.coordinates);
                } else {
                    // Else we want render an area
                    mapboxMap.registerGeoJSON('place', response.data, {
                        paint: {
                            'fill-opacity': 0.2,
                            'fill-color': '#207dda',
                        },
                    });
                }
                mapboxMap.fitFeatures(response.data);
                resolve();
            });
        },
    });
}

function initializeTimer() {
    if (MA.Context.timeRemaining) {
        let duration = moment.duration(
            moment()
                .add(MA.Context.timeRemaining, 'seconds')
                .diff(moment()),
        );
        const interval = 1000;
        setInterval(() => {
            duration = duration.subtract(1, 'seconds');
            let timeStr = '';
            if (duration.days() > 0) {
                timeStr += `${duration.days()} ${duration.days() === 1 ? 'jour' : 'jours'}`;
                timeStr += ', ';
            }
            if (duration.hours() > 0) {
                timeStr += `${duration.hours()} ${duration.hours() === 1 ? 'heure' : 'heures'}`;
                timeStr += ', ';
            }
            if (duration.minutes() > 0) {
                timeStr += `${duration.minutes()} ${
                    duration.minutes() === 1 ? 'minute' : 'minutes'
                }`;
            }
            timeStr += ` et ${duration.seconds()} secondes`;
            $('#time-remaining').text(timeStr);
        }, interval);
    }
}

function initializeRealtorForm() {
    const buttons = document.querySelectorAll('[data-preview-realtor-form-button]');
    for (let i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', e => {
            e.currentTarget.classList.add('hide');
            e.currentTarget.nextElementSibling.classList.remove('hide');
        });
    }
}

function initTracking() {
    const { listing, listings, transactionType } = MA.Context;
    const avItemsArgs = {
        listing,
        listings,
        listName: 'classified_detail',
        name: 'classified',
        transactionType,
    };
    thorPushEvent('page_view', {
        ...getThorViewEventProps('classified', 'classified_detail'),
        av_estate_type_global: EstateType[listing.item_type.key],
        av_distribution_type_global: thorDistributionType(transactionType),
        av_city: thorFormatPlaceName(listing.place.name),
        av_zip_code: listing.zip,
        av_items: thorAvItems({
            ...avItemsArgs,
            listsName: 'classified_detail_similars_bottom',
        }),
    });
    thorPushEvent(eventTypeWithEstateType('classified_detail_view', transactionType), {
        av_estate_type_global: EstateType[listing.item_type.key],
        av_distribution_type_global: thorDistributionType(transactionType),
        av_items: thorAvItems({
            ...avItemsArgs,
            listsName: 'classified_detail_similars_bottom',
        }),
        av_category: 'classified',
    });
    const $links = $('[data-listing-item]');
    $links.on('click', event => {
        if (event.target.nodeName !== 'A') return;
        const { index } = event.currentTarget.dataset;
        thorPushEvent('select_item', {
            av_estate_type_global: EstateType[listings[index].item_type.key],
            av_distribution_type_global: thorDistributionType(transactionType),
            av_items: thorAvItems(avItemsArgs),
        });
    });
}

export function domPreviewReady() {
    initializeTimer();
    MA.Context.realtors.forEach(realtor => {
        initializeRealtorContactForm(
            GA_CATEGORY,
            'listing:realtor:contact:form',
            WA_SOURCE,
            $(`[data-realtor-message-form-${realtor.id}]`),
        );
    });
    initializeRealtorMessagePopin(GA_CATEGORY, WA_SOURCE);
    initializeRealtorPhoneButton();
    initializeListingDetailButton();
    initializeMap();
    initializeSlider();
    Wa.setTracking();
    initializeRealtorForm();
    Wa.push(
        'page_view',
        'sale_preview_page',
        `campaign_id=${MA.Context.listingId}|path=${document.location.pathname}`,
    );
}

export function domReady() {
    initializeRealtorContactForm(
        GA_CATEGORY,
        'listing:realtor:contact:form',
        WA_SOURCE,
        $('[data-realtor-message-form]'),
    );
    initializeRealtorMessagePopin(GA_CATEGORY, WA_SOURCE);
    initializeRealtorPhoneButton();
    initializeListingDetailButton();
    initializeStickyContactForm(87); // 58 + 29 : navbar + margin
    handlePriceFeedback(`/annonces/${MA.Context.listingId}/feedback`);
    initializeMap();
    initializeSlider();
    Wa.push(
        'page_view',
        'listing_page',
        `listing_id=${MA.Context.listingId}|realtor_id=${MA.Context.realtorId}`,
    );
    Wa.push(
        'print',
        'realtor',
        `source=listing|realtor_id=${MA.Context.realtorId}|listing_id=${MA.Context.listingId}`,
    );
    Wa.setTracking();
    bindFollowListingButton();
    initTracking();
}
